var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "padlock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.66667 6.99996V4.99996C4.66667 3.15863 6.15867 1.66663 8 1.66663C9.84133 1.66663 11.3333 3.15863 11.3333 4.99996V6.99996M12.6667 16.3333H3.33333C2.59733 16.3333 2 15.736 2 15V8.33329C2 7.59729 2.59733 6.99996 3.33333 6.99996H12.6667C13.4027 6.99996 14 7.59729 14 8.33329V15C14 15.736 13.4027 16.3333 12.6667 16.3333ZM10 11.6666C10 12.7713 9.10467 13.6666 8 13.6666C6.89533 13.6666 6 12.7713 6 11.6666C6 10.562 6.89533 9.66663 8 9.66663C9.10467 9.66663 10 10.562 10 11.6666Z",
    stroke: "#050922",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.65073f0120d08f8be4d9bda4d12bbbd4.svg";
export { ForwardRef as ReactComponent };